import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './PackageTitleForPayment.scss';

const PackageTitleForPayment = ({ properties, highlight, price, isAgent }) => (
  <div className={cx(styles.packageWrapper, { [styles.publisherPackageWrapper]: !isAgent })}>
    <div className={styles.titleWrapper}>
      <div>{properties}</div>
      <div>{highlight}</div>
    </div>
    <div className={styles.priceWrapper}>
      <div>{price}</div>
    </div>
  </div>
);

PackageTitleForPayment.propTypes = {
  properties: PropTypes.node,
  highlight: PropTypes.node,
  price: PropTypes.string,
  isAgent: PropTypes.bool
};

export default PackageTitleForPayment;
